module.exports = __webpack_public_path__ + "img/circleOrange4.65d58991.svg";